import { setSendMessagePending } from './actions';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage } from '../../utils/messageUtils';
import { sendWsMessage } from '../wsMessage';

export const sendMessage =
  (text: string, chatId: string, messageId?: string): TThunkAction<void> =>
  async (dispatch, getState) => {
    const {
      user: { userId },
    } = getState();

    const message = createOutcomingMessage({ text, chatId, userId });

    dispatch(setSendMessagePending({ message, messageId: messageId || message.messageId }));

    await dispatch(sendWsMessage({ message }));
  };
